import React from 'react';
import AnalyticsSerive from 'api/services/AnalyticsService';
import { tailwindConfig, getI18nValue } from 'utils/Utils';
import HorizontalBarChart from 'charts/HorizontalBarChart';
import LayoutWrapper from 'components/LayoutWrapper';
import { useTranslation } from 'react-i18next';
import { useAxios } from 'hooks/useAxios';
import PropTypes from 'prop-types';

function TopIntentsChart({ dateRanges, channel, language }) {
    const { t, i18n } = useTranslation();
    const [data, error, loading] = useAxios(
        AnalyticsSerive.getTopIntents(dateRanges, channel, language)
    );

    const chartData = data?.intents
        ? {
              labels: data.intents.map((i) => i18n.language === 'en' ? (i.labelEn || i.intent) : (i.labelFr || i.intent)),
              datasets: [
                  {
                      label: t(getI18nValue('analytics.kpi.top_intents', 'title')),
                      data: data.intents.map((i) => i.count),
                      backgroundColor: tailwindConfig().theme.colors.blue[400],
                      hoverBackgroundColor: tailwindConfig().theme.colors.blue[500],
                      barPercentage: 0.66,
                      categoryPercentage: 0.66,
                  },
              ],
          }
        : null;

    return (
        <div className="col-span-full bg-white rounded-sm border border-gray-200 min-h-[360px] flex flex-col">
            <div className="px-4 pt-4 pb-2 border-b border-gray-100">
                <header className="capitalize text-lg font-semibold text-gray-800">
                    {t(getI18nValue('analytics.kpi.top_intents', 'title'))}
                </header>
                <p className="text-sm font-light">
                    {t(getI18nValue('analytics.kpi.top_intents', 'description'))}
                </p>
            </div>
            <LayoutWrapper error={error} loading={loading} variant="chart" isEmpty={!loading && !chartData} className="flex-1 min-h-0 p-2">
                {!!chartData && <HorizontalBarChart data={chartData} />}
            </LayoutWrapper>
        </div>
    );
}

TopIntentsChart.propTypes = {
  dateRanges: PropTypes.object.isRequired,
  channel: PropTypes.string,
  language: PropTypes.string,
};

export default TopIntentsChart;
